// Redux
import BasicUserInfos from '@/types/basic-user-infos';
import { AsyncResult, Action, ApiAction } from '../index';
import api from '../redux-api';

// Types
import { UsersState } from './types/users';

// Initial state
const INITIAL_STATE: UsersState = {};

// Actions
const GET_USER_INFOS: ApiAction = {
  type: 'connect/users/get-infos',
  endpoint: 'users/:id/',
};

const SET_USER_REPCODE: ApiAction = {
  type: 'connect/users/set-repcode',
  endpoint: 'users/:id/repcode',
};

// Reducer
export default function reducer(state: UsersState = INITIAL_STATE, action: Action): UsersState {
  switch (action.type) {
    default: {
      return state;
    }
  }
}

// Action Creators
export const getUserInfos =
  (id: string): AsyncResult<BasicUserInfos> =>
  () =>
    api.get(GET_USER_INFOS, { id }).then((res: { data: any }) => res.data);

export const setUserRepcode =
  (repcode: string): AsyncResult<void> =>
  (dispatch, getState) => {
    const userId = getState().auth.user?.id;
    return api.post(SET_USER_REPCODE, { id: userId }, { repcode });
  };
